import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';

export const listUri = ({ filter = {}, params } = {}) => {
  const user = getUser();
  console.log("user", user);

  const query = {
    id: 'listQuery',
  };

  if (user.username !== "superadmin") {
    query.addOnFilter = { dealerName: user.username };
  }

  return {
    query,
    aggregate: true,
    model: MODELS.ManageNoti,
  };
};

export const unsubNotiListUri = ({ filter = {}, params } = {}) => {
  const user = getUser();
  console.log("user", user);

  const query = {
    id: 'listQuery',
  };

  if (user.username !== "superadmin") {
    query.addOnFilter = { dealerName: user.username };
  }

  return {
    query,
    aggregate: true,
    model: MODELS.ManageNoti,
  };
};

export const editNotiUri = ({ navigation }) => ({
  query: {
    model: MODELS.ManageNoti,
    id: 'getNotiDetails',
    // relationValue: {
    //   model: MODELS.AVRulesModel,
    //   _id: navigation?.state?.params?.item?._id,
    //   relation: '_id',
    // },
    limit: 1,
  },
  model: MODELS.ManageNoti,
});

export const addNotiUri = ({ navigation }) => ({
  query: {
    model: MODELS.ManageNoti,
    id: 'getNotiDetails',
    // relationValue: {
    //   model: MODELS.AVRulesModel,
    //   _id: navigation?.state?.params?.saveId,
    //   relation: '_id',
    // },
    limit: 1,
  },
  model: MODELS.ManageNoti,
});
